import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { ContractList } from 'types/api'
import { BaseParams, BaseResponse } from 'types/utils'

export const contractsQueryKey = ['contracts']

export function useContracts({
  params
}: BaseParams<{
  type?: 'flat' | 'offer'
  limit?: number
  offset?: number
  flat?: string
  offer?: string
}> = {}) {
  async function getContracts() {
    const response = await apiClient.get<BaseResponse<ContractList>>(
      `${SNA_PREFIX}contracts`,
      { params }
    )

    return response.data
  }

  return useQuery({
    queryFn: getContracts,
    queryKey: [...contractsQueryKey, params]
  })
}
